package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.RocketW500Rounded: ImageVector
    get() {
        if (_rocketW500Rounded != null) {
            return _rocketW500Rounded!!
        }
        _rocketW500Rounded = Builder(name = "RocketW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(309.67f, 730.72f)
                quadToRelative(-9.02f, -26.35f, -16.69f, -53.61f)
                quadToRelative(-7.68f, -27.26f, -12.44f, -54.63f)
                lineToRelative(-44.13f, 30.09f)
                verticalLineToRelative(107.76f)
                lineToRelative(73.26f, -29.61f)
                close()
                moveTo(463.85f, 201.22f)
                quadToRelative(-47.28f, 51.71f, -74.61f, 133.13f)
                quadToRelative(-27.33f, 81.42f, -27.33f, 171.13f)
                quadToRelative(0.0f, 59.28f, 10.76f, 114.99f)
                quadToRelative(10.76f, 55.7f, 28.5f, 98.33f)
                lineTo(558.8f, 718.8f)
                quadToRelative(17.77f, -42.63f, 28.53f, -98.33f)
                quadToRelative(10.76f, -55.71f, 10.76f, -114.99f)
                quadToRelative(0.0f, -89.71f, -27.33f, -171.13f)
                reflectiveQuadToRelative(-74.61f, -133.13f)
                quadToRelative(-3.48f, -3.48f, -7.51f, -5.34f)
                quadToRelative(-4.03f, -1.86f, -8.64f, -1.86f)
                reflectiveQuadToRelative(-8.64f, 1.86f)
                quadToRelative(-4.03f, 1.86f, -7.51f, 5.34f)
                close()
                moveTo(479.95f, 518.8f)
                quadToRelative(-32.23f, 0.0f, -55.13f, -23.0f)
                quadToRelative(-22.91f, -23.0f, -22.91f, -55.3f)
                reflectiveQuadToRelative(22.96f, -55.21f)
                quadToRelative(22.95f, -22.9f, 55.18f, -22.9f)
                quadToRelative(32.23f, 0.0f, 55.13f, 22.95f)
                quadToRelative(22.91f, 22.96f, 22.91f, 55.19f)
                reflectiveQuadToRelative(-22.96f, 55.25f)
                quadToRelative(-22.95f, 23.02f, -55.18f, 23.02f)
                close()
                moveTo(650.33f, 730.72f)
                lineTo(723.59f, 760.33f)
                verticalLineToRelative(-107.76f)
                lineToRelative(-44.13f, -30.09f)
                quadToRelative(-4.76f, 27.37f, -12.44f, 54.63f)
                quadToRelative(-7.67f, 27.26f, -16.69f, 53.61f)
                close()
                moveTo(514.83f, 93.48f)
                quadToRelative(87.82f, 77.5f, 131.04f, 183.81f)
                quadToRelative(43.22f, 106.32f, 43.22f, 239.36f)
                lineTo(689.09f, 520.0f)
                lineToRelative(84.71f, 56.48f)
                quadToRelative(19.26f, 12.45f, 30.03f, 32.83f)
                quadToRelative(10.76f, 20.39f, 10.76f, 43.26f)
                verticalLineToRelative(175.13f)
                quadToRelative(0.0f, 24.1f, -19.89f, 37.54f)
                quadToRelative(-19.9f, 13.43f, -42.53f, 4.48f)
                lineTo(603.63f, 809.8f)
                lineTo(356.37f, 809.8f)
                lineTo(207.83f, 869.72f)
                quadToRelative(-22.63f, 9.19f, -42.53f, -4.36f)
                quadToRelative(-19.89f, -13.56f, -19.89f, -37.66f)
                verticalLineToRelative(-175.13f)
                quadToRelative(0.0f, -22.87f, 10.76f, -43.26f)
                quadToRelative(10.77f, -20.38f, 30.03f, -32.83f)
                lineTo(270.91f, 520.0f)
                verticalLineToRelative(-2.87f)
                quadToRelative(0.0f, -133.28f, 43.22f, -239.72f)
                quadToRelative(43.22f, -106.43f, 131.04f, -183.93f)
                quadToRelative(7.72f, -5.96f, 16.68f, -9.32f)
                quadToRelative(8.95f, -3.36f, 18.15f, -3.36f)
                reflectiveQuadToRelative(18.15f, 3.36f)
                quadToRelative(8.96f, 3.36f, 16.68f, 9.32f)
                close()
            }
        }
        .build()
        return _rocketW500Rounded!!
    }

private var _rocketW500Rounded: ImageVector? = null
